import type { IconDefinition } from '../index.tsx';

export const iconDuplicate: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconDuplicate',
  icon: [
    16,
    16,
    [],
    '',
    'M7.14819 0.25293C7.67909 0.113012 8.22357 0.427337 8.36792 0.957031L8.67847 2.09863L15.0251 3.77246C15.5622 3.9141 15.881 4.46608 15.7351 5.00195L13.0017 15.043C12.8574 15.5727 12.3129 15.8871 11.782 15.7471L4.63354 13.8613L4.66772 13.7373L4.21753 13.8564C3.68671 13.9963 3.14219 13.6819 2.9978 13.1523L0.264404 3.11133C0.118534 2.57546 0.43736 2.0225 0.974365 1.88086L7.14819 0.25293ZM11.1013 10.998C11.2472 11.5339 10.9283 12.0859 10.3914 12.2275L7.45581 13.002L11.6287 14.1025L14.072 5.125L9.14917 3.82617L11.1013 10.998ZM5.78882 3.94238L5.54858 5.76074C5.51268 6.00996 5.48804 6.23932 5.46753 6.4502L5.33179 6.48633C5.21504 6.33794 5.07976 6.1514 4.91772 5.92969L3.79175 4.47754L2.65796 4.78125L4.77417 7.3125L4.22046 10.6104L5.36206 10.3047L5.58472 8.51562L5.62573 8.18848C5.6548 8.00957 5.66811 7.86886 5.67651 7.77246L5.81226 7.73633C5.86787 7.81577 6.01569 8.01564 6.26343 8.33398L7.35034 9.77148L8.49194 9.46582L6.36304 6.88672L6.93042 3.63672L5.78882 3.94238Z',
  ],
};
